import axiosConfig from './axios_config'

export const apiURL = () => {
        if (axiosConfig.defaults.baseURL === undefined)
            return '';
        return axiosConfig.defaults.baseURL;
    }    

export const login = (username, password) => {
        let data = {}
        if (username && password) {
                data["email"] = username
                data["password"] = password
        }
        return axiosConfig.post('user/login', data).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const getLastScanList = (obj) => {
        return axiosConfig.post('scan/search', obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const register = (obj) => {
        return axiosConfig.post('user/register', obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const userInfo = (obj) => {
        return axiosConfig.post('user/info', obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const getScanResult = (guid, obj) => {
        return axiosConfig.post(`scan/result/${guid}`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const scanStart = (guid, obj) => {
        return axiosConfig.post(`scan/start/${guid}`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const scanStop = (guid, obj) => {
        return axiosConfig.post(`scan/stop/${guid}`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const downloadHTML = (guid, obj) => {
        return axiosConfig.post(`scan/result/export/html/${guid}`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const forgetPassword = (obj) => {
        return axiosConfig.post(`user/password/reset`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const changePassword = (obj) => {
        return axiosConfig.post(`user/password/change`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}
export const logout = (obj) => {
        return axiosConfig.post(`user/logout`, obj).catch(function (error) {
                return JSON.parse('{ "success": false }')
        })
}

